<template>
  <v-dialog v-model="show" :max-width="maxWidth">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col md="11">
            <div class="mt-4 title">
              <v-avatar v-if="icon" color="rgb(199, 220, 240)" size="40">
                <v-icon>{{icon}}</v-icon>
              </v-avatar>
              {{title}}
            </div>
          </v-col>
          <v-col md="1">
            <v-btn v-if="displayCloseBtn" icon @click="show = false" aria-label="close">
              <v-icon color="rgba(0, 0, 0, 0.54)">close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="content">{{message}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-for="action in actionsList" :key="action.name">
          <v-btn
            @click="returnHandler(action.name)"
            :aria-label="action.name"
            class="ma-2 textWhite btnPadding"
            :color="action.color"
            action.size
            :outlined="action.outlined"
            :height="btnHeight"
          >{{action.name}}</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "Dialog",
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: "675px"
    },
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    actions: {
      type: Array,
      default() {
        return [];
      }
    },
    displayCloseBtn: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ""
    },
    btnClass: {
      type: String,
      default: ""
    },
    btnHeight: {
      type: String,
      default: "50"
    },
    returnHandler: {
      type: Function,
      default: name => {
        return name;
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.openDialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    },
    actionsList() {
      return this.actions;
    }
  }
};
</script>
<style scoped>
.rightAlign {
  text-align: right;
}
.title {
  font-size: 20px;
  line-height: 30px;
  color: #041e42 !important;
}
.content {
  font-size: 16px;
  line-height: 24px;
  color: #041e42 !important;
}
.textWhite {
  color: #fff;
}
.v-card__actions .v-btn.btnPadding {
  padding: 0 16px;
}
</style>

<!--  Example to pass paramters to Dialog component
<Dialog 
    :visible="openDialog"
    title="Title of modal"
    maxWidth="520px"
    icon="security"
    :openDialog="openDialog"
    :displayCloseBtn="true"
    message="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras euismod, nunc sit amet tincidunt fermentum, augue mi volutpat lacus, vel lacinia nunc tortor eget urna. Fusce nec diam leo. Duis nec ipsum id sapien faucibus vestibulum."
    :actions="actionsList"
    @close="openDialog=false"
    :returnHandler="actionHandler"
/> 

actionsList :[{name: 'Dont do it', color:"#041E42", size: "large", outlined: true}, {name: 'Do it', color:"#041E42", size: "large", outlined: false}];
 -->